<template>
  <div class="app-container">
    <CrudTable
      entity="QueuedKwantumOrder"
      :allow-actions="true"
      :allow-create="false"
      :allow-edit="false"
      :allow-delete="true"
      :columns="columns"
      :on-row-dbl-click="() => {}"
      :generate-summary="generateSummary"
    />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        { field: 'm1_OrderNumberBuyer', label: 'kwantum.m1_OrderNumberBuyer', sortable: false },
        { field: 'm1_QueuedAt', label: 'kwantum.m1_QueuedAt', type: 'date', filter: { type: 'none' }, sortable: false },
        { field: 'm2_ProjectID', label: 'kwantum.m2_ProjectID', sortable: false },
        { field: 'm2_PurchaseNumber', label: 'kwantum.m2_PurchaseNumber', sortable: false },
        { field: 'm2_PolygonNumber', label: 'kwantum.m2_PolygonNumber', filter: { type: 'none' }, sortable: false },
        { field: 'm2_QueuedAt', label: 'kwantum.m2_QueuedAt', type: 'date', filter: { type: 'none' }, sortable: false },
        { field: 'failedYN', label: 'kwantum.failedYN', filter: { type: 'none' }, sortable: false },
        { field: 'errorMessage', label: 'kwantum.errorMessage', filter: { type: 'none' }, sortable: false }
      ]
    };
  },
  methods: {
    generateSummary(row) {
      if (row.m1_OrderNumberBuyer) {
        return row.m1_OrderNumberBuyer;
      } else {
        return row.m2_PurchaseNumber;
      }
    }
  }
};
</script>

<style scoped></style>
